<div class="table__container">
  <table class="table">
    <ng-content select="colgroup"></ng-content>
    <ng-content select="thead"></ng-content>

    <ng-container *ngIf="!loading; else loadingBlock">
      <ng-content select="tbody"></ng-content>
    </ng-container>

    <ng-content select="tfoot"></ng-content>
  </table>
</div>

<ng-template #loadingBlock>
  <tbody app-dt-body>
    <tr app-dt-body-tr class="table__loading-row" *ngFor="let _ of [1,2,3]; trackBy: trackByIndex">
      <td app-dt-body-td class="table__loading-cell" colspan="100%">
        <app-skeleton-loader variant="line" height="2rem"></app-skeleton-loader>
      </td>
    </tr>
  </tbody>
</ng-template>